module.exports = __webpack_public_path__ + "img/geburt_digital.23c3e470.jpg";